import {palette} from "../common";

export default {
    styleOverrides: {
        root: {
            paddingTop: '20px!important'
        }
    }
}
